// extracted by mini-css-extract-plugin
module.exports = {"detailOrderItemReservation":"DetailOrderItemPrepaid-Jtails_detailOrderItemReservation_2iBFS"};